import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const uniformAgriDiscards: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YYYY' },
  instructions: {
    software: 'UNIFORM-Agri',
  },
  type: 'uniform-agri-discards',
}
